import createAreaCustomerForm from './createTerminalFormModel';
const {
  formField: {
    // DATOS AREA 
    name,
    description,
    typeTerminal,
  } 
} = createAreaCustomerForm;

export default {
  [name.name]: '',
  [description.name]: '',
  [typeTerminal.name]: '',
  
};

